module.exports = __webpack_public_path__ + "media/images/logo/volgjezorg-77ddc60a8a8ebd6247c2081f3a31bce0.png";